import React from 'react'

function Footer() {
    return (
        <>
            <hr className="line" />
            <div className="padding-bottom">
                <p className="subpara-text"><b>Institute Address :</b> Thakur Institute of Management Studies Career Development and Research - Thakur Education Campus, Thakur Village, Kandivali East. Mumbai 400101.<br /> Phone Nos: 022- 28840484/91. E-mail ID: timscdr.tnp@thakureducation.org</p>
            </div>
        </>
    )
}

export default Footer
